import { useOutlet } from 'react-router-dom'

import { LayoutBase } from './layout/LayoutBase'

function HubPanel() {
  const outlet = useOutlet()

  return <LayoutBase>{outlet}</LayoutBase>
}

export default HubPanel
